import { apiUserAccountService } from '@api/services/account.apiService';
import { apiCopyTradingAccountCardUser } from '@api/services/copyTradingAccountCardUser.apiService';
import { apiInvestorAccount } from '@api/services/investorAccount.apiService';
import { apiMamManagerService } from '@api/services/mamManager.apiService';
import { apiMasterAccount } from '@api/services/masterAccount.apiService';
import { apiTradingAccountCardUser } from '@api/services/tradingAccountCardUser.apiService';
import { apiTradingAccountTypeCategoryUserService } from '@api/services/tradingAccountTypeCategoryUser.apiService';
import { apiTradingAccountTypeUser } from '@api/services/tradingAccountTypeUser.apiService';
import { apiTradingAccountUser } from '@api/services/tradingAccountUser.apiService';
import { apiTradingAccountUserSettings } from '@api/services/tradingAccountUserSettings.apiService';
import { apiTradingPlatform } from '@api/services/tradingPlatform.apiService';

class ApiService {
  private static _instance: ApiService;

  public ma = {
    account: apiUserAccountService,
    copyTradingAccountCardUser: apiCopyTradingAccountCardUser,
    investorAccount: apiInvestorAccount,
    mamManager: apiMamManagerService,
    masterAccount: apiMasterAccount,
    tradingAccountCardUser: apiTradingAccountCardUser,
    tradingAccountTypeUser: apiTradingAccountTypeUser,
    tradingAccountUser: apiTradingAccountUser,
    tradingAccountUserSettings: apiTradingAccountUserSettings,
    tradingAccountTypeCategoryUser: apiTradingAccountTypeCategoryUserService,
    tradingPlatform: apiTradingPlatform,
  };

  public static getInstance(): ApiService {
    if (!ApiService._instance) {
      ApiService._instance = new ApiService();
    }

    return ApiService._instance;
  }
}

export const api = ApiService.getInstance();
